export const reasons = {
  fetchGasLimitFailed: 'Fetch gas limit failed',
  nonceFetchFailed: 'Nonce fetch failed',
  balanceFetchFailed: 'Balance fetch failed',
  broadcastTxFailed: 'Broadcast tx failed',
  getTransactionByHashFailed: 'Get transaction by hash failed',
  ethCallErc20Failed: 'Eth call erc20 failed',
  insufficientFunds: 'Insufficient funds',
  bumpTxFailed: 'Bump tx failed',
}

const MAX_HINT_LENGTH = 100
// TODO: move this to be a generic error for all assets
export class EthLikeError extends Error {
  #hintStack

  /**
   * Creates an instance of EthLikeError.
   *
   * @param {string} message - Standard error message.
   * @param {string} reason - A constant indicating the generic failure. Must not contain any sensitive information such as private keys, transaction IDs, or wallet addresses.
   * @param {string} hint - A hint to help the user understand the error. Must not contain any sensitive information such as private keys, transaction IDs, or wallet addresses.
   */
  constructor({ message, reason, hint }) {
    super(message)
    this.name = 'EthLikeError'
    this.#hintStack = [hint] // NOTE: we can add more hints to the stack
    this.reason = reason
    this.hint = this.#extractHint(hint)
  }

  addHint = (hint) => {
    const filteredHint = this.#extractHint(hint)
    if (!filteredHint) {
      return this
    }

    this.#hintStack.push(hint)
    this.hint = `${this.#hintStack.join(':')}`
    return this
  }

  // NOTE: a class method for now, if we move this to be a generic error for all assets, each asset will have its own implementation
  #extractHint = (hint) => {
    if (!hint) return ''

    // Define regex patterns for sensitive information
    const sensitivePatterns = [
      /(?:0x)?[\dA-Fa-f]{20,}/g, // Pattern for hex values of 20 or more characters
      /(?:[A-Za-z]{3,20}\s+){11}[A-Za-z]{3,20}/g, // Pattern for 12-word phrases
      /[1-9A-HJ-NP-Za-km-z]{50,}/g, // Pattern for base58 strings of 50 or more characters
      /(?:[\d+/A-Za-z]{4}){3,}(?:[\d+/A-Za-z]{2}==|[\d+/A-Za-z]{3}=|[\d+/A-Za-z]{4})/g, // Pattern for base64 strings of 12 or more characters
    ]

    let filteredHint = hint

    // Check for sensitive information
    const containsSensitiveInfo = sensitivePatterns.some((pattern) => pattern.test(filteredHint))

    if (containsSensitiveInfo) {
      console.warn('Hint contains sensitive information and will be ignored.')
      return ''
    }

    // Limit length to 100 characters
    if (filteredHint.length > MAX_HINT_LENGTH) {
      filteredHint = filteredHint.slice(0, MAX_HINT_LENGTH - 3) + '...'
    }

    return filteredHint
  }
}

export const withErrorReason = async (promise, errorReason, hint) => {
  try {
    return await promise
  } catch (err) {
    if (err instanceof EthLikeError) {
      // ignore errorReason and add hint to stack
      err.addHint(hint)
      throw err
    }

    throw new EthLikeError({
      message: err.message,
      reason: errorReason,
      hint,
    })
  }
}
